<template>
  <div>
    <TeaserSitecore
      v-if="mobileScreen"
      :stageTeaser="true"
      jsonFileName="teaser1"
    ></TeaserSitecore>
    <TeaserSitecore jsonFileName="teaser2"></TeaserSitecore>
    <TeaserSitecore jsonFileName="teaser3"></TeaserSitecore>
    <TeaserSitecore jsonFileName="teaser4"></TeaserSitecore>
  </div>
</template>

<script setup lang="ts">
import TeaserSitecore from '@/components/rahmen/TeaserSitecore.vue'
import { computed } from 'vue'
import { useWindowSize } from '@vueuse/core'

const { width } = useWindowSize()

const mobileScreen = computed(() => {
  return width.value < 600
})
</script>
